import { render, staticRenderFns } from "./SubCategoriesView.vue?vue&type=template&id=882159fa&scoped=true&"
import script from "./SubCategoriesView.vue?vue&type=script&lang=js&"
export * from "./SubCategoriesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882159fa",
  null
  
)

export default component.exports